import React from 'react';
import { motion } from 'framer-motion';
import { useLoading } from '../../context/LoadingContext';

export default function PageAnimator({ children }) {
  const { isLoading } = useLoading();
  // Extraction des enfants de premier niveau
  const blocks = React.Children.toArray(children).filter(child => Boolean(child));

  const block1 = blocks[0] || null;
  const block2 = blocks[1] || null;
  const block3 = blocks[2] || null;
  const rest = blocks.slice(3);

  return (
    <>
      {block1 && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={isLoading ? { opacity: 0, y: -10 } : { opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          {block1}
        </motion.div>
      )}

      {block2 && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isLoading ? { opacity: 0, scale: 0.95 } : { opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {block2}
        </motion.div>
      )}

      {block3 && (
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={isLoading ? { opacity: 0, x: 20 } : { opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {block3}
        </motion.div>
      )}

      {/* Si jamais il y a plus de 3 blocs, on les affiche normalement ou avec la 3eme animation */}
      {rest.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isLoading ? { opacity: 0, y: 20 } : { opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {rest}
        </motion.div>
      )}
    </>
  );
}
